<template>
  <form ref="scrollTo" class="brochure-form" name="brochureRequest" @submit.prevent="submit" novalidate>

    <div v-if="apiError" class="error-message mb-20">
      <div class="error-message__icon"></div>
      <div class="error-message__text">
        <p>{{apiErrorMessage ? apiErrorMessage : 'The brochure request could not be completed!'}}</p>
      </div>      
    </div>

    <div class="brochure-form__introduction" v-html="data.formFillIntroductionHtml"></div>

    <Input
      v-for="(field, fieldName) in fields"
      :key="fieldName"
      :name="fieldName"
      :type="field.type"
      :label="field.label"
      :placeholder="field.label"
      :required="field.required !== false"
      :options="field.options"
      :pattern="field.pattern"
      :title="field.title"
      :vuexPath="vuexPath"
    />

    <AddressLookup :vuexPath="vuexAddressPath" :brandName="data.brand">
      <p>
        {{data.countryDownloadWarning}}
        <button class="link" @click="changeState" aria-label="Download a brochure" title="Click to download a brochure">Download a Brochure</button>
      </p>
    </AddressLookup>

    <div class="brochure-form__disclaimer" v-html="data.disclaimerHtml"></div>

    <Input
      name="marketingEmail"
      type="checkbox"
      :startingValue="true"
      :label="marketingEmailLabel()"
      :vuexPath="vuexPath"
    />

    <Input
      class="d-none"
      name="marketingMail"
      type="checkbox"
      :startingValue="true"
      :label="marketingMailLabel()"
      :vuexPath="vuexPath"
    />

    <button class="btn" aria-label="Request brochure" title="Click to request a brochure">Request Brochure</button>

    <div class="brochure-form__privacy">
      <p v-if="data.brochurePrivacy" v-html="data.brochurePrivacy"></p>

      <p v-else>
        {{data.privacyLinkMessage}}
        <a :href="data.privacyPolicyLink.url"
           :target="data.privacyPolicyLink.target">
           {{data.privacyPolicyLink.name}}
        </a>
      </p>
    </div>
  </form>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import Input from '../Form/Input.vue';
import AddressLookup from '../Form/AddressLookup.vue';
import ScrollTo from '@/vue/components/ScrollTo.vue';
import ValidationMixin from '@/vue/components/Form/validationMixin';

export default {
  mixins: [ValidationMixin],
  extends: ScrollTo,
  components: {
    Input,
    AddressLookup
  },
  data() {
    return {
      vuexPath: ['brochureRequest', 'form'],
      vuexAddressPath: ['brochureRequest', 'form', 'address'],
      fields: null,
      apiError: false,
      apiErrorMessage: ''
    };
  },
  computed: {
    ...mapState('brochureRequest', ['data']),
    ...mapGetters('brochureRequest', ['brochureFormIsValid'])
  },
  created() {
    this.fields = {
      title: {
        label: 'Title',
        placeholder: 'Please select',
        options: ['Mr', 'Mrs', 'Miss', 'Ms'],
      },
      firstName: {
        label: 'First Name',
        pattern: this.patterns.name,
        title: this.titles.name
      },
      lastName: {
        label: 'Surname',
        pattern: this.patterns.name,
        title: this.titles.name
      },
      email: {
        label: 'Email Address',
        type: 'email',
        required: true,
        pattern: this.patterns.email,
        title: this.titles.email

      },
      phoneNumber: {
        label: 'Phone Number',
        type: 'tel',
        required: false,
        pattern: this.patterns.numbersOnly,
        title: this.titles.numbersOnly
      }
    };
    this.apiError = this.data.apiError;
    this.apiErrorMessage = this.data.errorMessage;
  },
  methods: {
    submit() {
      // set forms as submitted to show error states if necessary
      this.$store.commit('setHasBeenSubmitted', this.vuexPath);

      // If is valid, send all brochure details to api
      if (this.brochureFormIsValid) {
        // Extract required fields
        const formData = this.$store.state.brochureRequest.form;

        const customer = {
          ...formData,
          firstName: formData.fields.firstName.value,
          lastName: formData.fields.lastName.value
        };

        // Check if marketingEmail is checked
        const marketingEmailChecked = formData.fields.marketingEmail && formData.fields.marketingEmail.value === true;
        const marketingMailChecked = formData.fields.marketingMail && formData.fields.marketingMail.value === true;

        if (marketingEmailChecked && marketingMailChecked) {
          GTM.newsletterSubscribe(customer, true);
        }

        const utmParams = this.getUtmParams();
        window.scroll(0, 0);
        this.$store.dispatch('brochureRequest/submitBrochure', utmParams);
      }
    },
    getUtmParams() {
      const urlParams = new URLSearchParams(window.location.search);
      const utmParams = {
        utmSource: urlParams.get('utm_source') || null,
        utmMedium: urlParams.get('utm_medium') || null,
      };
      return utmParams;
    },
    changeState() {
      this.$store.commit('brochureRequest/changeState');
    },

    marketingEmailLabel() {
      return `Yes please! E-mail me great offers and exciting new tours from ${this.data.brandNameFormatted}`;
    },

    marketingMailLabel() {
      return `Yes please! Post me the best offers and exciting new destinations from ${this.data.brandNameFormatted}`;
    },
  }
};
</script>
